import React, { useEffect, useRef, useState } from "react";
import { IonModal, IonHeader, IonContent, IonToolbar } from "@ionic/react";
import { useNavigate } from "react-router-dom";
import { actions } from "../../../Redux/store";
import { useSelector } from "react-redux";
import { useSocket } from "../../../Context/SocketContext/SocketProvider";
import RenderResponse from "./Components/RenderChatBotResponse";
import { useFirebaseRemoteParams } from "../../../Context/FirebaseContext/FirebaseContext";
import { useMixpanel } from "../../../Context/MixpanelContext/MixpanelProvider";
import FollowUpInput from "./Components/FollowUpInput";
import { hapticsImpactLight, skeletonWidths } from "./Services";
import SuggestedQuestions from "./Components/SuggestedQuestions";
import LikeDislikeButtons from "./Components/LikeDislikeButtons";
import RelatedQuestions from "./Components/RelatedQuestions";
import {
  transformConversationHistory,
  StructuredConversation,
} from "./utils/transformConversation";
import ChatBotHistory from "./Components/ChatBotHistory/ChatBotHistory";
import { getChatBotConversationHistoryById } from "../../../Controllers/ChatbotApi";
import ChatBotHistorySkeleton from "./Components/ChatBotHistory/ChatBotHistorySkeleton";
import chatInputIcon from "../../../assets/imgs/chat_input_icon.svg";
import chatInputBlackIcon from "../../../assets/imgs/chat_input_black_icon.svg";
import ChatbotSearchInput from "./Components/ChatbotSearchInput";
import ChatBotLoadingSkeletonUI from "./Components/ChatBotLoadingSkeletonUI";
import ChatbotHeader from "./Components/ChatbotHeader";
import { FadeText } from "../../ui/fade-text";
import { useLeagueStore } from "../../../zustandStore/leagueStore";
import { useRevenueCatAuth } from "../../../Context/RevenueCatContext/RevenueCatContext";
import { useSupabaseAuth } from "../../../Context/AuthContext/AuthContext";

export default function AiChatbotSeachModal() {
  const navigate = useNavigate();
  
  const {
    sendMessage,
    isLoading,
    messages,
    connectionError,
    startNewThread,
    threadId,
    checkpointId,
    chartResponse,
    resetChartResponse,
    followUpQuestions,
    resetFollowUpQuestions,
  } = useSocket();
  const [isFollowUpFocused, setIsFollowUpFocused] = useState(false); // New state to track follow-up input focus
  const Mixpanel = useMixpanel();
  const [suggestedQuestionsData, setSuggestedQuestionsData] = useState<any[]>(
    [],
  );
  const {
    isSubscribed,
  } = useRevenueCatAuth();

  const TrendingTopicsQuestions = [
    {
      id: 1,
      chatbot_suggestion: "List QBs by pressure rate faced in 2024",
    },
    {
      id: 2,
      chatbot_suggestion: "Is Travis Hunter a good pickup this year?",
    },
    {
      id: 3,
      chatbot_suggestion: "Who are the top 5 runnings backs right now?",
    },
  ];

  const DataVisualizationQuestions = [
    {
      id: 1,
      chatbot_suggestion: "Bar graph of QBs with the highest scramble rate",
    },
    {
      id: 2,
      chatbot_suggestion: "Pie chart of Bronco’s target distribution last year",
    },
    {
      id: 3,
      chatbot_suggestion: "Line graph of Malik Nabers air yards in 2024",
    },
  ];

  const modalData = useSelector(
    (state: any) => state.modal.chatbotSearchModal?.data,
  );
  const { selectedLeague } = useLeagueStore();

  console.log(selectedLeague, "selectedLeague");

  const [inputValue, setInputValue] = useState("");
  const [followUpInput, setFollowUpInput] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [streamedResponse, setStreamedResponse] = useState("");
  const { screenData } = useFirebaseRemoteParams();
  const postFix = process.env.REACT_APP_ENV === "stagging" ? "_stg" : "_prod";
  const chatbotDefaultSuggestions = `chatbot_defaultSuggestions${postFix}`;
  // relatedQuestions is now handled by followUpQuestions from socket context
  const [typingLoading, setTypingLoading] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(false); // Changed to false initially
  const [messageLoading, setMessageLoading] = useState(false); // New state for message loading
  const [followUpQuestionsLoading, setFollowUpQuestionsLoading] =
    useState(false); // New state for follow-up questions loading
  const isOpenSearchScreen = useSelector(
    (state: any) => state.modal.chatbotSearchModal?.open,
  );
  const followUpRef = useRef<HTMLTextAreaElement>(null);
  const renderResponseRef = useRef<any>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [showFollowUpInput, setShowFollowUpInput] = useState(false);
  const modal = useRef<HTMLIonModalElement>(null);
  const contentRef = useRef<any>(null);
  const latestResponseRef = useRef<HTMLDivElement>(null);
  const [conversationHistory, setConversationHistory] = useState<any[]>([]); // Add state for conversation history
  const [structuredConversations, setStructuredConversations] = useState<
    StructuredConversation[]
  >([]);
  const [lastSavedQuestion, setLastSavedQuestion] = useState<string>(""); // Track last saved question
  const [likeClicked, setLikeClicked] = useState(false);
  const [dislikeClicked, setDislikeClicked] = useState(false);
  const [likeAnimating, setLikeAnimating] = useState(false);
  const [dislikeAnimating, setDislikeAnimating] = useState(false);
  const [loadingConversationDetails, setLoadingConversationDetails] =
    useState<boolean>(false);
  // New state to track if we're in active chat mode vs just viewing history
  const [isActiveChatMode, setIsActiveChatMode] = useState<boolean>(false);
  const expandableTextareaRef = useRef<HTMLTextAreaElement>(null);
  const { useAuthStore } = useSupabaseAuth();
  const isSuperUser = useAuthStore.getState().profile?.is_super_user;
  const chatbotAccess = isSuperUser || isSubscribed;
  
  const threadIdCondition = modalData?.thread_id ? (structuredConversations.length === 0 && modalData?.thread_id) : false;
  interface SuggestedQuestionHandler {
    (question: string, questionType?: string): void;
  }
  // Add effect to transform conversation history when it changes
  useEffect(() => {
    const transformed = transformConversationHistory(conversationHistory);
    setStructuredConversations(transformed);
  }, [conversationHistory]);

  useEffect(() => {
    if (screenData && screenData[chatbotDefaultSuggestions]) {
      setSuggestedQuestionsData(
        JSON.parse(screenData[chatbotDefaultSuggestions]),
      );
    }
  }, [screenData]);

  useEffect(() => {
    // Check if modalData exists
    if (modalData) {
      setShowLoading(true);
      setStreamedResponse("");
      setShowSkeleton(true);

      // If we have a thread_id, we're loading conversation history
      // Don't enter active chat mode yet
      if (modalData.thread_id) {
        setIsActiveChatMode(false);
      } else if (modalData.hotQuestion) {
        // Handle hot question from push notification - set input but don't auto-send
        setShowLoading(false); // Don't show loading state
        setShowSkeleton(false); // Don't show skeleton
        setInputValue(modalData.hotQuestion);
        setCurrentQuestion(""); // Don't set current question yet
        setIsActiveChatMode(false); // Stay in input mode, don't enter active chat mode
        
        // Set cursor to end of input after setting the value
        setTimeout(() => {
          if (expandableTextareaRef.current) {
            const textarea = expandableTextareaRef.current;
            const length = modalData.hotQuestion.length;
            textarea.focus();
            textarea.setSelectionRange(length, length);
          }
        }, 100);
      } else if (modalData.showingSuggestion && modalData.suggestion) {
        setIsActiveChatMode(true);
        sendMessage(modalData.suggestion, modalData.thread_id || threadId);
        setInputValue(modalData.showingSuggestion);
        setCurrentQuestion(modalData.showingSuggestion);
      } else if (modalData.suggestion) {
        setIsActiveChatMode(true);
        setInputValue(modalData.suggestion);
        setCurrentQuestion(modalData.suggestion);
        sendMessage(modalData.suggestion, modalData.thread_id || threadId);
      }

      // Trigger haptic feedback
      hapticsImpactLight();
    }
  }, [modalData]);

  useEffect(() => {
    const fetchConversationDetails = async () => {
      if (!modalData?.thread_id) {
        setLoadingConversationDetails(false);
        return;
      }

      try {
        setLoadingConversationDetails(true);
        const response = await getChatBotConversationHistoryById(
          modalData?.thread_id,
        );
        if (response.status === 200 && response.data) {
          console.log("response.data", response.data);
          // Set the conversation history with the fetched data
          setConversationHistory(response.data);
        } else {
          console.error("Failed to fetch conversation details");
        }
      } catch (err) {
        console.error("Error fetching conversation details:", err);
      } finally {
        setLoadingConversationDetails(false);
      }
    };

    fetchConversationDetails();
  }, [modalData?.thread_id]);

  // Update your message processing useEffect
  useEffect(() => {
    if (messages && messages.length > 0) {
      const responseMessages = messages.filter((msg) => {
        return msg.type === "response";
      });

      if (responseMessages.length > 0) {
        // If skeleton is false, set messageLoading to true
        if (!showSkeleton) {
          setMessageLoading(true);
        }

        // Get the full response content
        const fullResponse = responseMessages
          .map((msg) => msg.content)
          .join("");

        setStreamedResponse(fullResponse);
      }
    }
  }, [messages]);

  useEffect(() => {
    if (!showLoading) return;

    if (!isLoading) {
      // If we have real content and loading is complete
      if (streamedResponse && streamedResponse.trim() !== "") {
        setShowSkeleton(false);
        setMessageLoading(false); // Message loading complete
        setFollowUpQuestionsLoading(false); // Follow-up questions loading complete
      }
      // Check if there are valid messages even if formatted response isn't fully processed yet
      else if (
        (connectionError === "Cannot send message: Not connected" ||
          streamedResponse === "") &&
        !(
          messages &&
          messages.length > 0 &&
          messages.some((msg) => msg.type === "response" && msg.content)
        )
      ) {
        setShowSkeleton(false);
        setStreamedResponse("Error. Please try again.");
        setMessageLoading(false); // Message loading complete
        setFollowUpQuestionsLoading(false); // Follow-up questions loading complete
      }
    } else {
      // Keep showing skeleton loader while loading
      // But only if we don't have any real content yet
      if (!streamedResponse || streamedResponse.trim() === "") {
        setShowSkeleton(true);
      } else {
        // Once we have real content, don't show skeleton anymore
        setShowSkeleton(false);
        // If there's content but still loading, set messageLoading to true
        setMessageLoading(true);
      }
    }
  }, [showLoading, isLoading, streamedResponse, connectionError, messages]);

  // Add effect to handle clicks outside the input area
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isFollowUpFocused &&
        containerRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        followUpRef.current !== event.target
      ) {
        handleFollowUpBlur();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFollowUpFocused]);

  // Add effect to trigger animation when showing follow-up input
  useEffect(() => {
    // When loading completes and skeleton is hidden, trigger the animation with a delay
    if (!showSkeleton && !isLoading) {
      // Small delay to allow content to settle before animating in the input
      const timer = setTimeout(() => {
        setShowFollowUpInput(true);
      }, 300); // 300ms delay for smooth appearance after content loads

      return () => clearTimeout(timer);
    } else {
      setShowFollowUpInput(false);
    }
  }, [showSkeleton, isLoading]);

  // Add an effect to scroll when the response is loaded
  useEffect(() => {
    if (
      isActiveChatMode &&
      !showSkeleton &&
      !messageLoading &&
      !typingLoading &&
      streamedResponse
    ) {
      // This will scroll to the latest response when it's fully loaded
      scrollToLatestResponse();
    }
  }, [showSkeleton, messageLoading, typingLoading, streamedResponse]);

  const toggleModals = () => {
    actions.modal.closeChatbotSearchModal(null);
  };

  const dismissKeyboard = () => {
    if (expandableTextareaRef.current) {
      expandableTextareaRef.current.blur();
    }
    if (followUpRef.current) {
      followUpRef.current.blur();
    }
  };

  const closeChatbotSeachModal = () => {
    // First dismiss the keyboard
    dismissKeyboard();

    // Stop haptic feedback in RenderResponse component
    if (
      renderResponseRef.current &&
      renderResponseRef.current.stopHapticFeedback
    ) {
      renderResponseRef.current.stopHapticFeedback();
    }

    // Small delay to ensure keyboard is dismissed before modal closes
    setTimeout(() => {
      toggleModals();
      setConversationHistory([]);
      setStructuredConversations([]);
      setLastSavedQuestion("");
      setLikeClicked(false);
      setDislikeClicked(false);
      setLikeAnimating(false);
      setDislikeAnimating(false);
      setIsActiveChatMode(false);
      resetFollowUpQuestions();
      setInputValue("");
      setShowLoading(false);
      setCurrentQuestion("");
      setStreamedResponse("");
      resetChartResponse();
    }, 100);
  };

  const handleModalPresent = () => {
    if (isSubscribed) {
      expandableTextareaRef.current?.focus();
    }
  };

  const handleNavigateToPaywall = () => {
    // Close the current modal first
    closeChatbotSeachModal();
    // Navigate to the paywall page
    navigate('/chatbot-paywall-v2');
  };

  // New function to save conversation before clearing state
  const saveCurrentConversation = () => {
    console.log("Saving conversation:", {
      currentQuestion,
      streamedResponse,
      lastSavedQuestion,
      currentHistoryLength: conversationHistory.length,
      chartData: chartResponse, // Log chart data for debugging
    });

    // Only save if we have content and haven't already saved this conversation
    if (
      currentQuestion &&
      streamedResponse &&
      currentQuestion !== lastSavedQuestion
    ) {
      // Create related questions string format if questions exist
      const relatedQuestionsAsString =
        followUpQuestions.length > 0
          ? followUpQuestions
              .map((question: string) => `<question>${question}</question>\n`)
              .join("")
          : "";

      // Determine liked status based on like/dislike state
      let likedStatus: boolean | null = null;
      if (likeClicked && !dislikeClicked) {
        likedStatus = true;
      } else if (!likeClicked && dislikeClicked) {
        likedStatus = false;
      }
      // Create the conversation entries as objects with correct types
      const newConversation = [
        {
          type: "human",
          content: currentQuestion,
        },
        {
          type: "ai",
          content: streamedResponse,
          threadId: threadId || "",
          checkpointId: checkpointId || "",
          liked: likedStatus,
          chart_data: chartResponse || null, // Add chart data to AI response
        },
      ];

      // Only add the related questions entry if there are questions
      if (relatedQuestionsAsString) {
        newConversation.push({
          type: "ai",
          content: relatedQuestionsAsString,
        });
      }

      // Update conversation history with a functional update to ensure we have the latest state
      setConversationHistory((prevHistory) => {
        // Filter out any non-object entries (like the mysterious "a" string)
        const validHistory = prevHistory.filter(
          (item) => typeof item === "object" && item !== null && "type" in item,
        );

        // Check if this conversation already exists in the history
        const alreadyExists = validHistory.some(
          (item) => item.type === "human" && item.content === currentQuestion,
        );

        // Only add if it doesn't already exist
        const updatedHistory = alreadyExists
          ? validHistory
          : [...validHistory, ...newConversation];
        console.log("Updated history:", updatedHistory);
        return updatedHistory;
      });

      // Mark this question as saved to prevent duplicates
      setLastSavedQuestion(currentQuestion);
    }
  };

  // Handle search button click
  const handleSearch = () => {
    if (inputValue.trim() === "") return;

    setIsActiveChatMode(true); // Entering active chat mode

    Mixpanel.trackEvent("enter_custom_prompt", {
      name: "Entered custom prompt in chatbot",
      chatbotQuery: inputValue,
    });
    if (
      renderResponseRef.current &&
      renderResponseRef.current.stopHapticFeedback
    ) {
      renderResponseRef.current.stopHapticFeedback();
    }

    setCurrentQuestion(inputValue);
    setShowLoading(true);
    // Reset the streamed response before sending a new message
    setStreamedResponse("");
    setShowSkeleton(true); // Start with skeleton visible
    setMessageLoading(false); // Reset message loading
    setFollowUpQuestionsLoading(false); // Reset follow-up questions loading
    resetFollowUpQuestions(); // Clear follow-up questions
    sendMessage(inputValue, modalData?.thread_id || threadId);

    // Trigger a single haptic feedback when search is initiated
    hapticsImpactLight();
  };

  // Handle suggested question click
  const handleSuggestedQuestion: SuggestedQuestionHandler = (question, questionType) => {
    // Save current conversation before starting new one
    saveCurrentConversation();

    setIsActiveChatMode(true); // Entering active chat mode

    // Determine the appropriate Mixpanel event based on question type
    let eventName = "select_premade_suggestion";
    let eventDisplayName = "Selected the Premade chatbot Suggestions";
    
    if (questionType === "trending_topic") {
      eventName = "submit_trending_topic_suggestion";
      eventDisplayName = "Selected trending topic suggestion";
    } else if (questionType === "data_viz") {
      eventName = "submit_data_viz_suggestion";
      eventDisplayName = "Selected data visualization suggestion";
    }

    Mixpanel.trackEvent(eventName, {
      name: eventDisplayName,
      chatbotQuery: question,
    });
    setInputValue(question);
    if (
      renderResponseRef.current &&
      renderResponseRef.current.stopHapticFeedback
    ) {
      renderResponseRef.current.stopHapticFeedback();
    }

    setCurrentQuestion(question);
    setShowLoading(true);
    setStreamedResponse("");
    setShowSkeleton(true);
    setMessageLoading(false); // Reset message loading
    setFollowUpQuestionsLoading(false); // Reset follow-up questions loading
    resetFollowUpQuestions(); // Clear follow-up questions
    sendMessage(question, modalData?.thread_id || threadId);
    setLikeClicked(false);
    setDislikeClicked(false);
    setLikeAnimating(false);
    setDislikeAnimating(false);
    // Reset last saved question flag for the new conversation
    setLastSavedQuestion("");

    // Trigger haptic feedback
    hapticsImpactLight();

    setTimeout(scrollToLatestResponse, 200);
  };

  // Handle follow-up question submission
  const handleFollowUpSubmit = () => {
    if (followUpInput.trim() === "") return;

    setIsActiveChatMode(true); // Entering active chat mode

    // Save current conversation before starting new one
    saveCurrentConversation();

    Mixpanel.trackEvent("enter_custom_prompt", {
      name: "Entered custom prompt in chatbot",
      chatbotQuery: followUpInput,
    });
    if (
      renderResponseRef.current &&
      renderResponseRef.current.stopHapticFeedback
    ) {
      renderResponseRef.current.stopHapticFeedback();
    }

    setCurrentQuestion(followUpInput);
    setStreamedResponse("");
    setShowSkeleton(true); // Show skeleton immediately
    setMessageLoading(false); // Reset message loading
    setFollowUpQuestionsLoading(false); // Reset follow-up questions loading
    resetFollowUpQuestions();
    sendMessage(followUpInput, modalData?.thread_id || threadId);
    setFollowUpInput(""); // Clear input
    setIsFollowUpFocused(false); // Reset focus state to restore default styles
    setLikeClicked(false);
    setDislikeClicked(false);
    setLikeAnimating(false);
    setDislikeAnimating(false);

    // Reset last saved question flag for the new conversation
    setLastSavedQuestion("");

    // Reset textarea height
    if (followUpRef.current) {
      followUpRef.current.style.height = "52px";
      followUpRef.current.blur(); // Remove focus from the textarea
    }

    // Trigger a single haptic feedback when follow-up question is submitted
    hapticsImpactLight();

    // Scroll to latest response after a short delay
    setTimeout(scrollToLatestResponse, 200);
  };

  // Add this function to scroll to the latest response
  const scrollToLatestResponse = () => {
    if (contentRef.current && latestResponseRef.current) {
      // Use setTimeout to ensure DOM is updated before scrolling
      setTimeout(() => {
        if (contentRef.current && latestResponseRef.current) {
          contentRef.current.scrollToPoint(
            0,
            latestResponseRef.current.offsetTop,
            500,
          );
        }
      }, 100);
    }
  };

  // Add this function for auto-grow functionality
  const adjustTextareaHeight = (element: HTMLTextAreaElement) => {
    if (!element) return;

    // Reset height to auto to get the correct scrollHeight
    element.style.height = "auto";

    // Get the scroll height (content height)
    const scrollHeight = element.scrollHeight;

    // Calculate new height (clamped between min and max)
    const minHeight = 52; // Minimum height (matches the default height)
    const maxHeight = 120; // Maximum height before scrolling begins

    const newHeight = Math.min(Math.max(scrollHeight, minHeight), maxHeight);

    // Apply the new height
    element.style.height = `${newHeight}px`;
  };

  // Update the onChange handler for the follow-up textarea to only auto-grow when focused
  const handleFollowUpChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFollowUpInput(e.target.value);

    // Only adjust height if focused
    if (isFollowUpFocused) {
      adjustTextareaHeight(e.target);
    } else {
      // Ensure height is fixed at 52px when not focused
      e.target.style.height = "52px";
    }
  };

  // Handle focus for follow-up input
  const handleFollowUpFocus = () => {
    if (!chatbotAccess) {
      handleNavigateToPaywall();
      return;
    }
    setIsFollowUpFocused(true);
  };

  // Handle blur for follow-up input - update to clear the value
  const handleFollowUpBlur = () => {
    setIsFollowUpFocused(false);
    // Clear the input value when focus is lost
    setFollowUpInput("");

    // Reset the height of the textarea to its original height (52px)
    if (followUpRef.current) {
      followUpRef.current.style.height = "52px";
    }
  };

  // Function to handle textarea input and auto-expand
  const handleTextareaInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(e.target.value);

    const textarea = e.target;
    // Reset height to get the correct scrollHeight
    textarea.style.height = "auto";

    // Calculate new height (clamped between min and max)
    const scrollHeight = textarea.scrollHeight;
    const minHeight = 48; // Minimum height in pixels
    const maxHeight = 150; // Maximum height before scrolling begins

    const newHeight = Math.min(Math.max(scrollHeight, minHeight), maxHeight);
    textarea.style.height = `${newHeight}px`;
  };

  function dismiss() {
    modal.current?.dismiss();
    closeChatbotSeachModal();
  }

  const handleModalWillDismiss = () => {
    dismissKeyboard();
    // Only start a new thread if we're not viewing an existing thread
    if (!modalData?.thread_id) {
      startNewThread(selectedLeague?.leagueId, selectedLeague?.ownerId);
    }

    if (
      renderResponseRef.current &&
      renderResponseRef.current.stopHapticFeedback
    ) {
      renderResponseRef.current.stopHapticFeedback();
    }
  };

  return (
    <>
      <IonModal
        onDidDismiss={dismiss}
        className={`full-modal`}
        isOpen={isOpenSearchScreen}
        backdropDismiss={false}
        onIonModalDidPresent={handleModalPresent}
        onWillDismiss={handleModalWillDismiss}
        ref={modal}
      >
        {!showLoading ? (
          <>
            <IonHeader className="ion-no-border modal-ion-header">
              <IonToolbar className="custom-toolbar">
                <ChatbotHeader dismiss={dismiss} showLeagueSkeleton={true} />
              </IonToolbar>
            </IonHeader>
            <IonContent>
              <div className="px-[20px]">
                <ChatbotSearchInput
                  inputValue={inputValue}
                  onInputChange={handleTextareaInput}
                  onSearch={handleSearch}
                  inputRef={expandableTextareaRef}
                  chatInputIcon={chatInputIcon}
                  chatInputBlackIcon={chatInputBlackIcon}
                  placeholder={chatbotAccess ? "Type your question here..." : "Enter custom prompt..."}
                  chatbotAccess={chatbotAccess}
                  onNavigateToPaywall={handleNavigateToPaywall}
                />
                <SuggestedQuestions
                  suggestedQuestionsData={suggestedQuestionsData}
                  onQuestionClick={handleSuggestedQuestion}
                  TrendingTopicsQuestions={TrendingTopicsQuestions}
                  DataVisualizationQuestions={DataVisualizationQuestions}
                  chatbotAccess={chatbotAccess}
                />
              </div>
            </IonContent>
          </>
        ) : (
          <>
            <IonHeader className="ion-no-border modal-ion-header">
              <IonToolbar className="custom-toolbar">
                <ChatbotHeader
                  dismiss={closeChatbotSeachModal}
                  showTitle={
                    structuredConversations.length > 0 ||
                    (structuredConversations.length <= 0 && !showSkeleton)
                  }
                />
              </IonToolbar>
            </IonHeader>

            <IonContent ref={contentRef}>
              {loadingConversationDetails ? (
                <ChatBotHistorySkeleton itemCount={2} />
              ) : (
                <>
                  <div>
                    {structuredConversations?.map((chat, index) => (
                      <ChatBotHistory
                        key={index}
                        userQuestion={chat.userQuestion}
                        botResponse={chat.botResponse}
                        relatedQuestions={chat.relatedQuestions}
                        liked={chat.liked}
                        threadId={chat.thread_Id}
                        checkpointId={chat.checkpoint_Id}
                        onQuestionClick={handleSuggestedQuestion}
                        typingLoading={typingLoading}
                        followUpQuestionsLoading={followUpQuestionsLoading}
                        showSkeleton={showSkeleton}
                        messageLoading={messageLoading}
                        modalDatathreadId={modalData?.thread_id}
                        chartData={chat?.chart_data}
                      />
                    ))}
                  </div>
                  
                  {/* Show message when no conversations found but thread_id exists */}
                  {threadIdCondition && (
                    <div className="flex items-center justify-center mt-20">
                      <div className="text-center text-white/50 text-lg font-medium">
                      No chatbot history found.
                      </div>
                    </div>
                  )}
                  <div
                    className={`px-[20px] pt-[20px] pb-[100px] ${structuredConversations.length > 0 && currentQuestion !== "" ? "h-[100%]" : ""}`}
                    ref={latestResponseRef}
                  >
                    {showSkeleton ? (
                      <ChatBotLoadingSkeletonUI
                        currentQuestion={currentQuestion}
                        inputValue={inputValue}
                        skeletonWidths={skeletonWidths}
                        handleSearch={handleSearch}
                      />
                    ) : (
                      <>
                        {isActiveChatMode && (
                          <div>
                            <FadeText
                              className="text-[20px] text-white font-semibold"
                              direction="up"
                              framerProps={{
                                show: { transition: { delay: 0.2 } },
                              }}
                              text={currentQuestion}
                            />

                            <div className="flex-col space-y-[7px] mt-[10px]">
                              <RenderResponse
                                streamedResponse={streamedResponse}
                                isLoading={messageLoading}
                                setTypingLoading={setTypingLoading}
                                typingLoading={typingLoading}
                                ref={renderResponseRef}
                                chartResponse={chartResponse}
                              />
                            </div>
                          </div>
                        )}

                        {isActiveChatMode &&
                          !messageLoading &&
                          !showSkeleton &&
                          !typingLoading && (
                            <LikeDislikeButtons
                              threadId={threadId}
                              checkpointId={checkpointId}
                              likeClicked={likeClicked}
                              dislikeClicked={dislikeClicked}
                              likeAnimating={likeAnimating}
                              dislikeAnimating={dislikeAnimating}
                              setLikeClicked={setLikeClicked}
                              setDislikeClicked={setDislikeClicked}
                              setLikeAnimating={setLikeAnimating}
                              setDislikeAnimating={setDislikeAnimating}
                            />
                          )}

                        {followUpQuestions.length > 0 && (
                          <RelatedQuestions
                            relatedQuestions={followUpQuestions}
                            followUpQuestionsLoading={followUpQuestionsLoading}
                            onQuestionClick={handleSuggestedQuestion}
                            typingLoading={typingLoading}
                          />
                        )}

                        {!showSkeleton && !messageLoading && !typingLoading && !threadIdCondition && (
                          <FollowUpInput
                            followUpRef={followUpRef}
                            containerRef={containerRef}
                            followUpInput={followUpInput}
                            isFollowUpFocused={isFollowUpFocused}
                            showFollowUpInput={showFollowUpInput}
                            handleFollowUpChange={handleFollowUpChange}
                            handleFollowUpFocus={handleFollowUpFocus}
                            handleFollowUpBlur={handleFollowUpBlur}
                            handleFollowUpSubmit={handleFollowUpSubmit}
                          />
                        )}
                      </>
                    )}
                  </div>
                </>
              )}
            </IonContent>
          </>
        )}
      </IonModal>
    </>
  );
}
